import { lazy } from 'react';

const VerifyCircularityConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/verifier/verify-circularity',
			component: lazy(() => import('./VerifyCircularityContainer'))
		}
	]
};

export default VerifyCircularityConfig;
